var map = {
	"./de-DE/player.json": [
		15313,
		7701
	],
	"./en-AU/player.json": [
		9698,
		5427
	],
	"./en-CA/player.json": [
		39061,
		3036
	],
	"./en-GB/player.json": [
		26720,
		8737
	],
	"./en-US/player.json": [
		68125,
		3438
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 31811;
module.exports = webpackAsyncContext;